import { CLEAR_PAGE } from '../base/types';
import { FETCH_FILTERS, CREATE_FILTER, UPDATE_FILTER, DELETE_FILTER } from './actionsTypes';

const INIT_STATE = {
  isLoading: false,
  isLoaded: false,
  data: [],
};

const filtersReducer = (state = INIT_STATE, { type, payload }) => {
  switch (type) {
    case `${FETCH_FILTERS}_PENDING`:
      return {
        ...state,
        isLoading: true,
      };
    case `${FETCH_FILTERS}_FULFILLED`:
      return {
        ...state,
        data: payload,
        isLoading: false,
        isLoaded: true,
      };
    case `${FETCH_FILTERS}_REJECTED`:
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };

    case `${CREATE_FILTER}_FULFILLED`:
      return {
        ...state,
        data: [payload, ...state.data],
      };
    case `${UPDATE_FILTER}_FULFILLED`:
      return {
        ...state,
        data: state.data.map((i) => {
          if (Number(i.id) === Number(payload.id)) {
            return payload;
          }
          return i;
        }),
      };
    case `${DELETE_FILTER}_FULFILLED`:
      return {
        ...state,
        data: state.data.filter((i) => Number(i.id) !== Number(payload?.id)),
      };

    case CLEAR_PAGE:
      return payload === 'filters' ? INIT_STATE : state;

    default:
      return state;
  }
};

export default filtersReducer;
